import { render, staticRenderFns } from "./OverlayMenuData.vue?vue&type=template&id=764ae721&"
import script from "./OverlayMenuData.vue?vue&type=script&lang=js&"
export * from "./OverlayMenuData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports